/* global IntersectionObserver */
document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.ss-card, .swv-card');

    if (!cards.length) {return;}

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startCounters(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.3 },
    );

    cards.forEach(card => observer.observe(card));

    function startCounters(card) {
        const counters = card.querySelectorAll('.stat-counter');

        counters.forEach(counter => {
            const originalValue = counter.dataset.count;
            if (!originalValue) {return;}

            const finalValue = parseFloat(originalValue.replace(/,/g, ''));
            if (isNaN(finalValue)) {return;}

            const decimals = originalValue.includes('.')
                ? originalValue.split('.')[1].length
                : 0;

            const duration = finalValue < 10 ? 800 : 1200;
            let start = null;

            function animate(timestamp) {
                if (!start) {start = timestamp;}

                const progress = timestamp - start;
                const step = Math.min(progress / duration, 1);
                const current = finalValue * step;

                counter.textContent = format(originalValue, current, decimals);

                if (step < 1) {
                    requestAnimationFrame(animate);
                } else {
                    counter.textContent = originalValue;
                }
            }

            requestAnimationFrame(animate);
        });
    }

    function format(original, current, decimals) {
        const value = current.toFixed(decimals);
        return original.includes(',')
            ? Number(value).toLocaleString()
            : value;
    }
});
